<template>
    <template v-if="Object.keys(validationErrors).length > 0">
        <div class="z-20 rounded-3xl bg-salmon px-6 py-2 text-[10px] text-white text-center">
            <p>Vaši vnosi vsebujejno napake, prosimo dopolnite oz. popravite podatke.</p>
            <template v-if="validationErrors.db_error_nr">
                <p>(Št. napake: {{ validationErrors.db_error_nr[0] }})</p>
            </template>
        </div>
    </template>
</template>

<script>
export default {
    props: {

        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },

    }
}
</script>